export const BrandLogo = ({ className = "h-12", alt = "80 Metrics — Smarter Property Decisions" }) => (
  <img
    src="/assets/logo-main.png"
    alt={alt}
    width="800"
    height="800"
    className={`block shrink-0 ${className}`}
  />
);
